import { AppointmentProposalOptionModifier } from '../../data-access/appointmentProposalOptionModifiers';
import { AppointmentProposalOptionProduct } from '../../data-access/appointmentProposalOptionProducts';
import { AppointmentProposalOption } from '../../data-access/appointmentProposalOptions';

export const mapOptionSyncErrors = <
  T extends
    | AppointmentProposalOption
    | AppointmentProposalOptionProduct
    | AppointmentProposalOptionModifier,
>(
  optionItem: T
): T => {
  const getErrorMessage = (type: string | undefined) => {
    const operationType = optionItem.externalIds?.length
      ? 'updating'
      : 'creating';

    const defaultError =
      optionItem.entityType === 'APPOINTMENT_PROPOSAL_OPTION'
        ? `An error occurred while ${operationType} the estimate on ServiceTitan`
        : `An error occurred while ${operationType} estimate items on ServiceTitan`;

    const message = (
      optionItem.errorDetail?.message ||
      optionItem.errorDetail?.code ||
      'Unknown error'
    )
      .toString()
      .trim();

    switch (type) {
      case 'MISSING_ESTIMATE_ITEM_ERROR':
        return 'We were unable to find the estimate item in ServiceTitan. Has it been deleted in ServiceTitan?';
      case 'MISSING_ESTIMATE_ERROR':
        return 'We were unable to find the estimate in ServiceTitan. Has it been deleted in ServiceTitan?';
      case 'UNMANAGED_TECHNICIANS':
        return 'The technicians on this job are non-managed type in ServiceTitan. Please update the technicians to managed in ServiceTitan and try again.';
      case 'SOLD_BY_USER_NOT_FOUND':
        return 'The user who sold is not connected to a ServiceTitan account. Please mark the estimate as SOLD manually in ServiceTitan.';
      default:
        return `${defaultError} - ${message}`;
    }
  };

  return {
    ...optionItem,
    ...(optionItem.errorDetail && {
      errorDetail: {
        ...optionItem.errorDetail,
        message: getErrorMessage(optionItem.errorDetail?.type),
      },
    }),
  };
};
